var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspotAddon = function SvgHotspotAddon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.914 13.6q0 1.576.84 2.893a5.25 5.25 0 0 0 2.26 1.977q-.18-.272-.269-.566a2 2 0 0 1-.088-.601q0-.538.213-1.02t.598-.867l1.932-1.904 1.95 1.904q.385.386.589.867.204.482.204 1.02a2.1 2.1 0 0 1-.357 1.167 5.25 5.25 0 0 0 2.26-1.977q.84-1.318.84-2.893a5.6 5.6 0 0 0-.423-2.16 5.6 5.6 0 0 0-1.223-1.817 3.613 3.613 0 0 1-1.989.594q-1.434 0-2.474-.937a3.53 3.53 0 0 1-1.183-2.344 12.4 12.4 0 0 0-1.577 1.548 10 10 0 0 0-1.154 1.664 8 8 0 0 0-.709 1.72q-.24.869-.24 1.732m5.486 1.189-1.303 1.28a1.8 1.8 0 0 0-.388.571 1.7 1.7 0 0 0-.138.663q0 .731.538 1.257.537.526 1.291.526a1.78 1.78 0 0 0 1.291-.526q.538-.526.538-1.257a1.6 1.6 0 0 0-.138-.674 1.9 1.9 0 0 0-.388-.56zm-.914-9.61V6.56q0 1.164.8 1.953.802.79 1.965.79.429 0 .837-.145.405-.145.769-.418l.394-.31a6.16 6.16 0 0 1 1.874 2.262q.675 1.37.675 2.908 0 2.676-1.862 4.538T10.4 20t-4.538-1.862T4 13.6q0-2.35 1.476-4.598t4.01-3.824M19.543 10.4a.44.44 0 0 1-.326-.131.44.44 0 0 1-.131-.326q0-.195.13-.326a.44.44 0 0 1 .327-.131q.195 0 .326.13a.44.44 0 0 1 .131.327q0 .195-.131.326a.44.44 0 0 1-.326.131m-.457-2.532V4H20v3.868z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FA4F25",
    d: "M19.143 10.313a.48.48 0 0 0 .357.143.48.48 0 0 0 .357-.143.48.48 0 0 0 .143-.357.48.48 0 0 0-.143-.357.48.48 0 0 0-.357-.143.48.48 0 0 0-.357.143.48.48 0 0 0-.143.357q0 .213.143.357M19 4v4.23h1V4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hotspot-addon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FA4F25",
    d: "M13.188 17.454c0 1.51-1.242 2.546-2.774 2.546s-2.773-1.036-2.773-2.546.56-1.788 2.773-3.97c2.152 2.122 2.774 2.46 2.774 3.97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hotspot-addon_svg__a",
    width: 7.547,
    height: 8.516,
    x: 6.641,
    y: 12.484,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4291_11988"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4291_11988",
    result: "shape"
  })))));
};
export default SvgHotspotAddon;